module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "m-secNavi"
  }, [_vm._t("default", [_c('li', [_vm._v("メニューがありません")])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37983acb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/SecNavi.vue
// module id = 1334
// module chunks = 0